// Recruitment landing page copy (FR / EN / ES). Merged into the main dictionaries in i18n/index.js.
const TRACKS_FR = {
  sales_business_development: "Vente / développement des affaires",
  automotive: "Automobile",
  real_estate: "Immobilier",
  financial_services_insurance: "Services financiers / assurance",
  marketing_client_acquisition: "Marketing / acquisition clients",
  events_field: "Événements / terrain",
  ambassador_representation: "Ambassadeur / représentation",
  leadership_team_management: "Leadership / gestion d'équipe",
  discover_possibilities: "Je veux découvrir les possibilités",
  other: "Autre",
};

const TRACKS_EN = {
  sales_business_development: "Sales / business development",
  automotive: "Automotive",
  real_estate: "Real estate",
  financial_services_insurance: "Financial services / insurance",
  marketing_client_acquisition: "Marketing / client acquisition",
  events_field: "Events / field",
  ambassador_representation: "Ambassador / representation",
  leadership_team_management: "Leadership / team management",
  discover_possibilities: "I want to explore the possibilities",
  other: "Other",
};

const TRACKS_ES = {
  sales_business_development: "Ventas / desarrollo de negocios",
  automotive: "Automotriz",
  real_estate: "Inmobiliario",
  financial_services_insurance: "Servicios financieros / seguros",
  marketing_client_acquisition: "Marketing / captación de clientes",
  events_field: "Eventos / terreno",
  ambassador_representation: "Embajador / representación",
  leadership_team_management: "Liderazgo / gestión de equipos",
  discover_possibilities: "Quiero descubrir las posibilidades",
  other: "Otro",
};

const STRENGTHS_FR = {
  customer_service: "Service à la clientèle",
  field_sales: "Vente terrain",
  phone: "Téléphone",
  prospecting: "Prospection",
  business_development: "Développement des affaires",
  automotive: "Automobile",
  real_estate: "Immobilier",
  finance: "Finance",
  events: "Événementiel",
  team_management: "Gestion d'équipe",
  leadership: "Leadership",
  marketing_social_media: "Marketing / médias sociaux",
  other: "Autre",
};

const STRENGTHS_EN = {
  customer_service: "Customer service",
  field_sales: "Field sales",
  phone: "Phone",
  prospecting: "Prospecting",
  business_development: "Business development",
  automotive: "Automotive",
  real_estate: "Real estate",
  finance: "Finance",
  events: "Events",
  team_management: "Team management",
  leadership: "Leadership",
  marketing_social_media: "Marketing / social media",
  other: "Other",
};

const STRENGTHS_ES = {
  customer_service: "Servicio al cliente",
  field_sales: "Ventas en terreno",
  phone: "Teléfono",
  prospecting: "Prospección",
  business_development: "Desarrollo de negocios",
  automotive: "Automotriz",
  real_estate: "Inmobiliario",
  finance: "Finanzas",
  events: "Eventos",
  team_management: "Gestión de equipos",
  leadership: "Liderazgo",
  marketing_social_media: "Marketing / redes sociales",
  other: "Otro",
};

export const join = {
  fr: {
    kicker: "Développement · Opportunités · Progression",
    title: "Développez votre potentiel avec Consultants Sparks",
    lead:
      "Nous développons des personnes, des équipes, des projets et des parcours professionnels. "
      + "Dites-nous ce qui vous intéresse et notre équipe vous orientera vers les possibilités qui correspondent à votre profil.",
    cta: "Je veux découvrir les opportunités",
    ctaSecondary: "Parler à quelqu'un",
    valueTitle: "Ce que vous trouverez ici",
    values: [
      { title: "Un accompagnement réel", body: "Vous êtes rencontré par une personne, pas filtré par un algorithme. Chaque parcours est évalué humainement." },
      { title: "Des univers variés", body: "Vente et développement des affaires, immobilier, services financiers, automobile, campagnes, leadership et projets." },
      { title: "De l'apprentissage", body: "Orientation, formation et progression structurée. On développe des compétences avant de développer des résultats." },
      { title: "Un environnement moderne", body: "Des outils actuels, des équipes engagées et des projets qui avancent." },
    ],
    processTitle: "Comment ça se passe",
    process: [
      "Vous remplissez trois courtes étapes, environ trois minutes.",
      "Notre équipe examine ce que vous avez transmis.",
      "Léa, notre assistante virtuelle, peut vous appeler pour compléter certaines informations.",
      "Une entrevue humaine est planifiée lorsque c'est pertinent.",
    ],
    honesty:
      "Aucun revenu, aucune commission, aucune entrevue et aucun poste ne sont garantis. Les possibilités varient selon le profil, l'expérience et les besoins des organisations.",
    formTitle: "Votre candidature",
    steps: ["01 · Identité", "02 · Intérêts", "03 · Profil rapide"],
    identity: {
      first_name: "Prénom",
      last_name: "Nom",
      email: "Courriel",
      phone: "Téléphone",
      city: "Ville",
      province_state: "Province / région",
      country: "Pays",
      age: "Je confirme avoir 18 ans ou plus.",
    },
    interestsTitle: "Qu'est-ce qui vous intéresse ?",
    interestsHint: "Choisissez tout ce qui vous parle. Ce sont des intérêts, pas une affectation.",
    tracks: TRACKS_FR,
    profile: {
      salesTitle: "Votre expérience en vente",
      sales: { none: "Aucune", beginner: "Débutant", intermediate: "Intermédiaire", experienced: "Expérimenté" },
      strengthsTitle: "Vos expériences et vos forces",
      strengths: STRENGTHS_FR,
      languagesTitle: "Langues parlées",
      languagesHint: "Français, anglais, espagnol, autres…",
      availabilityTitle: "Disponibilité",
      availability: { full_time: "Temps plein", part_time: "Temps partiel", flexible: "Flexible" },
      goalTitle: "Qu'est-ce que vous aimeriez accomplir ou changer professionnellement dans les prochains mois ?",
      goalPlaceholder: "En quelques lignes, à votre rythme.",
    },
    resumeTitle: "Votre CV (facultatif)",
    resumeHint: "PDF, DOC, DOCX, JPG ou PNG · 8 Mo maximum. Vous pourrez aussi l'ajouter plus tard.",
    resumeChoose: "Choisir un fichier",
    resumeUploading: "Téléversement…",
    consentTitle: "Traitement de votre candidature",
    consent:
      "J'accepte que Consultants Sparks traite, enregistre et conserve ma candidature, et me tienne informé du suivi administratif de mon dossier par courriel ou par message texte. Cette case ne constitue pas un consentement à un appel téléphonique ni à un échange avec une intelligence artificielle.",
    consentLeaTitle: "Être contacté par Léa",
    consentLeaHint:
      "Pour recevoir l'appel de préqualification, les DEUX autorisations ci-dessous doivent être cochées. Si une seule est cochée, aucun appel automatique n'aura lieu et votre dossier sera traité par un membre de l'équipe. Ces autorisations sont facultatives : un refus n'affecte en rien votre candidature.",
    consentLeaReady: "Les deux autorisations sont cochées : Léa pourra vous appeler.",
    consentLeaIncomplete:
      "Il manque une autorisation : aucun appel automatique ne sera effectué, un membre de l'équipe prendra le relais.",
    consentOptionalTitle: "Autres choix facultatifs",
    consentOptionalHint:
      "Ces choix sont facultatifs : un refus n'affecte en rien votre candidature, qui sera alors traitée manuellement par un membre de l'équipe.",
    consentDncHint:
      "Choix durable : une fois enregistré, ce refus ne peut pas être retiré automatiquement, y compris lors d'une prochaine candidature. Seule une demande explicite auprès de notre équipe peut le lever.",
    consentDncActive:
      "Vous avez demandé à ne recevoir aucun appel : les deux autorisations d'appel sont désactivées.",
    consentPhone:
      "J'accepte qu'un membre de l'équipe de Consultants Sparks me contacte par téléphone au numéro fourni afin de traiter ma candidature et de discuter d'opportunités d'emploi pouvant correspondre à mon profil.",
    consentAi:
      "J'accepte que mon premier échange de qualification puisse être effectué par Léa, l'assistante virtuelle de Consultants Sparks, au moyen d'un appel automatisé ou assisté par intelligence artificielle. Cet appel peut être enregistré et transcrit afin de compléter mon profil. Léa ne prend aucune décision finale d'embauche ou de rejet. Je peux refuser ce type d'appel sans que ma candidature soit affectée, demander un suivi humain et demander l'arrêt des appels à tout moment.",
    consentDnc:
      "Je demande à ne recevoir aucun appel téléphonique, ni d'un membre humain ni d'un agent automatisé. Ma candidature demeure valide et sera traitée, lorsque possible, par un autre moyen de communication. Cette interdiction ne pourra être retirée automatiquement.",
    next: "Continuer",
    back: "Retour",
    submit: "Envoyer ma candidature",
    submitting: "Envoi…",
    errors: {
      step: "Veuillez remplir les champs obligatoires de cette étape avant de continuer.",
      required: "Ce champ est obligatoire.",
      email: "Veuillez saisir une adresse courriel valide.",
      phone: "Veuillez saisir un numéro de téléphone valide.",
      age: "Vous devez confirmer avoir 18 ans ou plus.",
      consent: "Le consentement de communication est requis.",
      tracks: "Choisissez au moins un intérêt.",
      server: "Un problème est survenu. Veuillez réessayer dans un instant.",
      resume: "Ce fichier n'a pas pu être téléversé. Votre candidature reste enregistrée.",
    },
    successTitle: "Merci, votre candidature a bien été reçue.",
    successBody:
      "Notre équipe va examiner les informations transmises. Léa, l'assistante virtuelle de Consultants Sparks, pourrait communiquer avec vous afin de compléter certaines informations et de planifier une entrevue lorsque pertinent. Vous pouvez également utiliser Ask Vytali sur cette page si vous avez des questions générales sur le processus.",
    successPhone: "Vous préférez parler à quelqu'un maintenant ?",
    backHome: "Retour au site",
  },

  en: {
    kicker: "Development · Opportunities · Progression",
    title: "Grow your potential with Consultants Sparks",
    lead:
      "We develop people, teams, projects and professional paths. Tell us what interests you and our team will guide you toward the possibilities that fit your profile.",
    cta: "I want to explore the opportunities",
    ctaSecondary: "Talk to someone",
    valueTitle: "What you will find here",
    values: [
      { title: "Real support", body: "You are met by a person, not filtered by an algorithm. Every path is assessed by humans." },
      { title: "Varied fields", body: "Sales and business development, real estate, financial services, automotive, campaigns, leadership and projects." },
      { title: "Learning", body: "Orientation, training and structured progression. We develop skills before we develop results." },
      { title: "A modern environment", body: "Current tools, committed teams and projects that move forward." },
    ],
    processTitle: "How it works",
    process: [
      "You complete three short steps, about three minutes.",
      "Our team reviews what you shared.",
      "Léa, our virtual assistant, may call you to complete a few details.",
      "A human interview is scheduled when relevant.",
    ],
    honesty:
      "No income, commission, interview or position is guaranteed. Possibilities vary based on profile, experience and organizational needs.",
    formTitle: "Your application",
    steps: ["01 · Details", "02 · Interests", "03 · Quick profile"],
    identity: {
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      phone: "Phone",
      city: "City",
      province_state: "Province / region",
      country: "Country",
      age: "I confirm that I am 18 years of age or older.",
    },
    interestsTitle: "What interests you?",
    interestsHint: "Pick everything that speaks to you. These are interests, not an assignment.",
    tracks: TRACKS_EN,
    profile: {
      salesTitle: "Your sales experience",
      sales: { none: "None", beginner: "Beginner", intermediate: "Intermediate", experienced: "Experienced" },
      strengthsTitle: "Your experience and strengths",
      strengths: STRENGTHS_EN,
      languagesTitle: "Languages spoken",
      languagesHint: "French, English, Spanish, others…",
      availabilityTitle: "Availability",
      availability: { full_time: "Full time", part_time: "Part time", flexible: "Flexible" },
      goalTitle: "What would you like to achieve or change professionally in the coming months?",
      goalPlaceholder: "A few lines, at your own pace.",
    },
    resumeTitle: "Your CV (optional)",
    resumeHint: "PDF, DOC, DOCX, JPG or PNG · 8 MB maximum. You can also add it later.",
    resumeChoose: "Choose a file",
    resumeUploading: "Uploading…",
    consentTitle: "Processing of your application",
    consent:
      "I agree that Consultants Sparks may process, record and retain my application, and keep me informed about the administrative handling of my file by email or text message. This box is not a consent to a phone call or to an exchange with an artificial intelligence.",
    consentLeaTitle: "Being contacted by Léa",
    consentLeaHint:
      "To receive the pre-qualification call, BOTH authorisations below must be checked. If only one is checked, no automated call will take place and your file will be handled by a team member. These authorisations are optional: declining does not affect your application.",
    consentLeaReady: "Both authorisations are checked: Léa will be able to call you.",
    consentLeaIncomplete:
      "One authorisation is missing: no automated call will be made, a team member will take over.",
    consentOptionalTitle: "Other optional choices",
    consentOptionalHint:
      "These choices are optional: declining does not affect your application, which will then be handled manually by a team member.",
    consentDncHint:
      "Lasting choice: once recorded, this refusal cannot be lifted automatically, including on a future application. Only an explicit request to our team can lift it.",
    consentDncActive:
      "You asked to receive no calls: both call authorisations are disabled.",
    consentPhone:
      "I agree that a member of the Consultants Sparks team may contact me by phone at the number provided in order to process my application and to discuss employment opportunities that may match my profile.",
    consentAi:
      "I agree that my initial qualification conversation may be conducted by Léa, the Consultants Sparks virtual assistant, by means of an automated or AI-assisted call. The call may be recorded and transcribed in order to complete my profile. Léa makes no final hiring or rejection decision. I may decline this type of call without affecting my application, request human follow-up, and ask that calls stop at any time.",
    consentDnc:
      "I ask to receive no phone calls at all, neither from a human team member nor from an automated agent. My application remains valid and will be handled, where possible, through another means of communication. This restriction cannot be lifted automatically.",
    next: "Continue",
    back: "Back",
    submit: "Send my application",
    submitting: "Sending…",
    errors: {
      step: "Please complete the required fields of this step before continuing.",
      required: "This field is required.",
      email: "Please enter a valid email address.",
      phone: "Please enter a valid phone number.",
      age: "You must confirm that you are 18 or older.",
      consent: "Communication consent is required.",
      tracks: "Choose at least one interest.",
      server: "Something went wrong. Please try again in a moment.",
      resume: "This file could not be uploaded. Your application is still saved.",
    },
    successTitle: "Thank you, your application has been received.",
    successBody:
      "Our team will review the information you shared. Léa, the Consultants Sparks virtual assistant, may contact you to complete certain information and to schedule an interview when relevant. You can also use Ask Vytali on this page if you have general questions about the process.",
    successPhone: "Would you rather speak to someone now?",
    backHome: "Back to the site",
  },

  es: {
    kicker: "Desarrollo · Oportunidades · Progresión",
    title: "Desarrolle su potencial con Consultants Sparks",
    lead:
      "Desarrollamos personas, equipos, proyectos y trayectorias profesionales. Cuéntenos qué le interesa y nuestro equipo le orientará hacia las posibilidades que correspondan a su perfil.",
    cta: "Quiero descubrir las oportunidades",
    ctaSecondary: "Hablar con alguien",
    valueTitle: "Lo que encontrará aquí",
    values: [
      { title: "Acompañamiento real", body: "Le recibe una persona, no un algoritmo. Cada trayectoria se evalúa de forma humana." },
      { title: "Ámbitos variados", body: "Ventas y desarrollo de negocios, inmobiliario, servicios financieros, automotriz, campañas, liderazgo y proyectos." },
      { title: "Aprendizaje", body: "Orientación, formación y progresión estructurada. Desarrollamos competencias antes que resultados." },
      { title: "Un entorno moderno", body: "Herramientas actuales, equipos comprometidos y proyectos que avanzan." },
    ],
    processTitle: "Cómo funciona",
    process: [
      "Completa tres etapas cortas, unos tres minutos.",
      "Nuestro equipo revisa la información enviada.",
      "Léa, nuestra asistente virtual, puede llamarle para completar algunos datos.",
      "Se planifica una entrevista humana cuando es pertinente.",
    ],
    honesty:
      "No se garantiza ningún ingreso, comisión, entrevista ni puesto. Las posibilidades varían según el perfil, la experiencia y las necesidades de las organizaciones.",
    formTitle: "Su candidatura",
    steps: ["01 · Identidad", "02 · Intereses", "03 · Perfil rápido"],
    identity: {
      first_name: "Nombre",
      last_name: "Apellido",
      email: "Correo electrónico",
      phone: "Teléfono",
      city: "Ciudad",
      province_state: "Provincia / región",
      country: "País",
      age: "Confirmo que tengo 18 años o más.",
    },
    interestsTitle: "¿Qué le interesa?",
    interestsHint: "Elija todo lo que le llame la atención. Son intereses, no una asignación.",
    tracks: TRACKS_ES,
    profile: {
      salesTitle: "Su experiencia en ventas",
      sales: { none: "Ninguna", beginner: "Principiante", intermediate: "Intermedio", experienced: "Experimentado" },
      strengthsTitle: "Sus experiencias y fortalezas",
      strengths: STRENGTHS_ES,
      languagesTitle: "Idiomas que habla",
      languagesHint: "Francés, inglés, español, otros…",
      availabilityTitle: "Disponibilidad",
      availability: { full_time: "Tiempo completo", part_time: "Tiempo parcial", flexible: "Flexible" },
      goalTitle: "¿Qué le gustaría lograr o cambiar profesionalmente en los próximos meses?",
      goalPlaceholder: "Unas líneas, a su ritmo.",
    },
    resumeTitle: "Su CV (opcional)",
    resumeHint: "PDF, DOC, DOCX, JPG o PNG · 8 MB máximo. También puede añadirlo más tarde.",
    resumeChoose: "Elegir un archivo",
    resumeUploading: "Subiendo…",
    consentTitle: "Tramitación de su candidatura",
    consent:
      "Acepto que Consultants Sparks trate, registre y conserve mi candidatura, y me mantenga informado del seguimiento administrativo de mi expediente por correo electrónico o mensaje de texto. Esta casilla no constituye un consentimiento a una llamada telefónica ni a un intercambio con una inteligencia artificial.",
    consentLeaTitle: "Ser contactado por Léa",
    consentLeaHint:
      "Para recibir la llamada de precalificación, deben marcarse LAS DOS autorizaciones siguientes. Si solo se marca una, no se realizará ninguna llamada automática y su expediente será tramitado por un miembro del equipo. Estas autorizaciones son facultativas: una negativa no afecta a su candidatura.",
    consentLeaReady: "Las dos autorizaciones están marcadas: Léa podrá llamarle.",
    consentLeaIncomplete:
      "Falta una autorización: no se realizará ninguna llamada automática, un miembro del equipo tomará el relevo.",
    consentOptionalTitle: "Otras opciones facultativas",
    consentOptionalHint:
      "Estas opciones son facultativas: una negativa no afecta a su candidatura, que será tratada manualmente por un miembro del equipo.",
    consentDncHint:
      "Elección duradera: una vez registrada, esta negativa no puede retirarse automáticamente, incluso en una futura candidatura. Solo una solicitud explícita a nuestro equipo puede levantarla.",
    consentDncActive:
      "Ha solicitado no recibir ninguna llamada: las dos autorizaciones de llamada están desactivadas.",
    consentPhone:
      "Acepto que un miembro del equipo de Consultants Sparks me contacte por teléfono al número proporcionado con el fin de tramitar mi candidatura y conversar sobre oportunidades de empleo que puedan corresponder a mi perfil.",
    consentAi:
      "Acepto que mi primera conversación de calificación pueda ser realizada por Léa, la asistente virtual de Consultants Sparks, mediante una llamada automatizada o asistida por inteligencia artificial. La llamada puede ser grabada y transcrita con el fin de completar mi perfil. Léa no toma ninguna decisión final de contratación ni de rechazo. Puedo rechazar este tipo de llamada sin que mi candidatura se vea afectada, solicitar un seguimiento humano y pedir que se detengan las llamadas en cualquier momento.",
    consentDnc:
      "Solicito no recibir ninguna llamada telefónica, ni de un miembro humano ni de un agente automatizado. Mi candidatura sigue siendo válida y será tramitada, cuando sea posible, por otro medio de comunicación. Esta prohibición no podrá retirarse automáticamente.",
    next: "Continuar",
    back: "Volver",
    submit: "Enviar mi candidatura",
    submitting: "Enviando…",
    errors: {
      step: "Complete los campos obligatorios de esta etapa antes de continuar.",
      required: "Este campo es obligatorio.",
      email: "Introduzca una dirección de correo electrónico válida.",
      phone: "Introduzca un número de teléfono válido.",
      age: "Debe confirmar que tiene 18 años o más.",
      consent: "El consentimiento de comunicación es obligatorio.",
      tracks: "Elija al menos un interés.",
      server: "Ocurrió un problema. Vuelva a intentarlo en un momento.",
      resume: "No se pudo subir este archivo. Su candidatura queda registrada.",
    },
    successTitle: "Gracias, hemos recibido su candidatura.",
    successBody:
      "Nuestro equipo revisará la información enviada. Léa, la asistente virtual de Consultants Sparks, podría comunicarse con usted para completar cierta información y planificar una entrevista cuando sea pertinente. También puede usar Ask Vytali en esta página si tiene preguntas generales sobre el proceso.",
    successPhone: "¿Prefiere hablar con alguien ahora?",
    backHome: "Volver al sitio",
  },
};

export default join;
